import {ArticleEntity} from "../contract/article";

export type ArticleAction = SetArticleAction|SetArticlesAction|RemoveArticlesAction;

interface SetArticleAction {
  type: 'article/set';
  payload: ArticleEntity;
}

interface SetArticlesAction {
  type: 'article/setMultiple';
  payload: ArticleEntity[];
}

interface RemoveArticlesAction {
  type: 'article/removeMultiple';
  payload: string[];
}

// -------
// article/set
// -------
export function setArticle(article: ArticleEntity): SetArticleAction {
  return {
    type: 'article/set',
    payload: article,
  };
}

// -------
// article/setMultiple
// -------
export function setArticles(articles: ArticleEntity[]): SetArticlesAction {
  return {
    type: 'article/setMultiple',
    payload: articles,
  };
}

// -------
// article/removeMultiple
// -------
export function removeArticles(ids: string[]): RemoveArticlesAction {
  return {
    type: 'article/removeMultiple',
    payload: ids,
  };
}
